import { AWCButton, BUTTON_TYPES } from '../../../GlobalComponents/Inputs/Inputs'
import { ErrorTable } from '../UI/ErrorTable'
import { hasErrors } from '../Utility/LOBFunction'
import style from '../UI/ErrorTable.module.scss'

export const FileImportedResults = (props: FileImportedProps) => {
    return (
        <div className={style.errorTableContainer}>
            {hasErrors(props.UploadData) ? (
                <ErrorTable importData={props.UploadData} />
            ) : (
                <>
                    <p>{props.message}</p>
                    {props.showButton && (<AWCButton
                        onClick={props.onUploadClick}
                        type={BUTTON_TYPES.PRIMARY}
                        style={{ marginTop: 10, alignSelf: 'flex-end', marginRight: '9%' }}
                    >
                        Upload
                    </AWCButton>)}
                </>
            )}
        </div>
    )
}
